/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_IntensityInputs */

const en_us2_profile_editors_pain_intensity = /** @type {(inputs: Profile_Editors_Pain_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does it hurt?`)
};

const pt_br2_profile_editors_pain_intensity = /** @type {(inputs: Profile_Editors_Pain_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto dói?`)
};

const es_419_profile_editors_pain_intensity = /** @type {(inputs: Profile_Editors_Pain_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto duele?`)
};

const pt_pt2_profile_editors_pain_intensity = /** @type {(inputs: Profile_Editors_Pain_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto dói?`)
};

const fr_fr2_profile_editors_pain_intensity = /** @type {(inputs: Profile_Editors_Pain_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À quel point ça fait mal ?`)
};

const de_de2_profile_editors_pain_intensity = /** @type {(inputs: Profile_Editors_Pain_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie stark tut es weh?`)
};

const it_it2_profile_editors_pain_intensity = /** @type {(inputs: Profile_Editors_Pain_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto fa male?`)
};

/**
* | output |
* | --- |
* | "How much does it hurt?" |
*
* @param {Profile_Editors_Pain_IntensityInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_intensity = /** @type {((inputs?: Profile_Editors_Pain_IntensityInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_IntensityInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_intensity(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_intensity(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_intensity(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_intensity(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_intensity(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_intensity(inputs)
	return en_us2_profile_editors_pain_intensity(inputs)
});
export { profile_editors_pain_intensity as "profile-editors.pain_intensity" }